// Camada de acesso à administração de usuários. Todas as operações chamam
// funções SECURITY DEFINER no banco, que exigem que o chamador seja admin da
// organização — a autorização real é do banco, não da tela.
import { supabase } from './supabase';
import type { AppRole } from './database.types';

/** Senha padrão dos novos usuários (troca obrigatória no 1º acesso). */
export const DEFAULT_PASSWORD = 'npd1234';

export interface AdminUserRow {
  user_id: string;
  email: string;
  full_name: string | null;
  role: AppRole;
  must_change_password: boolean;
  area_keys: string[];
  created_at: string | null;
}

export async function listUsers(orgId: string): Promise<AdminUserRow[]> {
  const { data, error } = await supabase.rpc('admin_list_users', { p_org: orgId });
  if (error) throw new Error(error.message);
  return (data ?? []) as AdminUserRow[];
}

export async function createUser(params: {
  orgId: string;
  email: string;
  role: AppRole;
  areaKeys: string[];
  fullName?: string;
  password?: string;
}): Promise<void> {
  const { error } = await supabase.rpc('admin_create_user', {
    p_org: params.orgId,
    p_email: params.email,
    p_password: params.password ?? DEFAULT_PASSWORD,
    p_role: params.role,
    p_area_keys: params.areaKeys,
    p_full_name: params.fullName ?? null,
  });
  if (error) throw new Error(error.message);
}

export async function resetPassword(
  orgId: string,
  userId: string,
  password: string = DEFAULT_PASSWORD,
): Promise<void> {
  const { error } = await supabase.rpc('admin_reset_password', {
    p_org: orgId,
    p_user_id: userId,
    p_password: password,
  });
  if (error) throw new Error(error.message);
}

export async function setUserRoleAreas(
  orgId: string,
  userId: string,
  role: AppRole,
  areaKeys: string[],
): Promise<void> {
  const { error } = await supabase.rpc('admin_set_user', {
    p_org: orgId,
    p_user_id: userId,
    p_role: role,
    p_area_keys: areaKeys,
  });
  if (error) throw new Error(error.message);
}

export async function deleteUser(orgId: string, userId: string): Promise<void> {
  const { error } = await supabase.rpc('admin_delete_user', {
    p_org: orgId,
    p_user_id: userId,
  });
  if (error) throw new Error(error.message);
}
